export default "__VITE_ASSET__42799653__"